import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { CredentialPolicy } from "./CredentialPolicy";
/**
 * AnonymousCredentialPolicy is used with HTTP(S) requests that read public resources
 * or for use with Shared Access Signatures (SAS).
 */

export var AnonymousCredentialPolicy = /*#__PURE__*/function (_CredentialPolicy) {
  _inherits(AnonymousCredentialPolicy, _CredentialPolicy);

  /**
   * Creates an instance of AnonymousCredentialPolicy.
   * @param nextPolicy -
   * @param options -
   */
  // The base class has a protected constructor. Adding a public one to enable constructing of this class.

  /* eslint-disable-next-line @typescript-eslint/no-useless-constructor*/
  function AnonymousCredentialPolicy(nextPolicy, options) {
    _classCallCheck(this, AnonymousCredentialPolicy);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnonymousCredentialPolicy).call(this, nextPolicy, options));
  }

  return AnonymousCredentialPolicy;
}(CredentialPolicy);